import React from 'react';
import { RenderIfProps } from './RenderIf.types';

const RenderIf = ({ children, isTrue }: RenderIfProps) => {
  return isTrue ? <>{children}</> : null;
};

export default RenderIf;
